'use client';
import React from 'react';
import classNames from 'classnames';
import { Impression } from '@benzinga/analytics';
import { AnalyticsContext } from '@benzinga/analytics';

import { ArticleBlocks } from './ArticleBlocks';
import { CloseContainer } from '@benzinga/ui';
import { useBenzingaEdge } from '@benzinga/edge';
import styles from './ArticlePopup.module.scss';

export interface ArticlePopupProps {
  popup: any;
}

export const ArticlePopup: React.FC<ArticlePopupProps> = ({ popup }) => {
  const [isVisible, setIsVisible] = React.useState(false);
  const [didDismiss, setDidDismiss] = React.useState(false);
  const hasAdLight = useBenzingaEdge().adLightEnabled;
  const handleOnClose = React.useCallback(() => {
    setIsVisible(false);
    setDidDismiss(true);
  }, []);

  // Disabled:: Show popup by default after 5 sec
  // React.useEffect(() => {
  //   setTimeout(() => setIsVisible(true), popup.duration ?? 5000);
  // });

  React.useEffect(() => {
    const handleExitIntent = () => {
      setIsVisible(false);
      setDidDismiss(true);
    };
    window.addEventListener('form_submit', handleExitIntent);
    return () => {
      window.removeEventListener('form_submit', handleExitIntent);
    };
  }, [isVisible, didDismiss]);

  React.useEffect(() => {
    const handleExitIntent = e => {
      if (e.keyCode === 27) {
        setIsVisible(false);
        setDidDismiss(true);
      }
    };
    window.addEventListener('keydown', handleExitIntent);
    return () => {
      window.removeEventListener('keydown', handleExitIntent);
    };
  }, [isVisible, didDismiss]);

  React.useEffect(() => {
    const handleExitIntent = event => {
      if (!event.toElement && !event.relatedTarget) {
        if (!isVisible && !didDismiss && !hasAdLight) {
          setIsVisible(true);
        }
      }
    };
    document.addEventListener('mouseout', handleExitIntent);
    return () => {
      window.removeEventListener('mouseout', handleExitIntent);
    };
  }, [isVisible, didDismiss, hasAdLight]);

  const popupClassName = isVisible && !didDismiss ? 'visible' : '';

  return (
    <AnalyticsContext.Provider value={{ label: 'Article Popup' }}>
      <div className={classNames(styles.wrapper, popupClassName)}>
        <CloseContainer onClose={handleOnClose}>
          <Impression campaign_id={popup.title ?? 'Unknown'} tag={'Article Popup'} unit_type="Popup CTA">
            <ArticleBlocks blocks={popup.blocks} />
          </Impression>
        </CloseContainer>
      </div>
    </AnalyticsContext.Provider>
  );
};
